import { PaddingType } from 'common/types/styleTypes'
import { mobilePaddingsCss, paddingsCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

type CarouselUiProps = {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
}

const CarouselUi = styled.div<CarouselUiProps>`
  position: relative;
  ${paddingsCss}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
    `}
`

export default CarouselUi
